<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.exteriorTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nombre_stationnement"
                                      prop="nombre_stationnement"
                                     >
                            <el-input  v-mask="'#################'" v-model.number="post.nb_place" type="nb_place">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'

export default {
  name: 'PostEditImmoObject1400',
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
